"use strict";

angular.module("customer")
.directive("footer", function() {
    return {
        templateUrl: require("./footer.html"),
        controller: function(
            $state, $scope, $rootScope, ToggleNav, $document, $timeout, PreferredService, PromotionFilterService
        ) {
            $scope.showFooter = ($state.current.name !== "customer-listing" && $state.current.name !== "partnership-listing");
            $scope.$on('UserUpdated', function() {
                $scope.showFooter = ($state.current.name !== "customer-listing" && $state.current.name !== "partnership-listing");
            });
            $scope.$on('UserWithoutCustomerUpdated', function() {
                $scope.showFooter = ($state.current.name !== "customer-listing" && $state.current.name !== "partnership-listing");
            });

            $scope.toggle = function() {
                ToggleNav.toggle();
            };

            var orderCountElement = angular.element("#OrdersCount");
            $scope.$on("OrdersCountChanged", function() {
                orderCountElement.removeClass("animated bounce");
                _.defer(function() {
                    orderCountElement.addClass("animated bounce");
                });
            });

            $scope.iOSKeyboardVisible = false;
            document.addEventListener("deviceready", function() {
                $document.on("focus", "input, textarea, select", function() {
                    $scope.iOSKeyboardVisible = true;
                });
                $document.on("blur", "input, textarea, select", function() {
                    var isModalOpened = ($(".modal").data("bs.modal") || {}).isShown;
                    $timeout(function() {
                        $scope.iOSKeyboardVisible = false;
                    }, isModalOpened ? 200 : 0)
                });
            }, false);

            $scope.togglePreferred = function() {
                PreferredService.togglePreferred();
            };

            $scope.togglePromotionFilter = function() {
                PromotionFilterService.togglePromotionFilter();
            };
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/footer/footer.controller.js
// module id = 788
// module chunks = 0